import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule, InputModule, ValidationErrorModule } from '@lib/components';
import { EmailModalComponent } from './email-modal.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StaticMsgModule } from '@lib/pipes';

@NgModule({
  declarations: [EmailModalComponent],
  imports: [
    CommonModule,
    ButtonModule,
    StaticMsgModule,
    InputModule,
    FormsModule,
    ReactiveFormsModule,
    ValidationErrorModule,
  ],
  exports: [EmailModalComponent],
})
export class EmailModalModule {}
